const CONTENT = {
  privacy: {
    title: "Privacy Policy",
    eyebrow: "Privacy",
    intro: "ScholarPrintHub respects your privacy. This policy explains what data we collect, how we use it, and how we protect it.",
    sections: [
      ["Data we collect", "Name, email, mobile, delivery address, uploaded documents, and order details necessary to fulfil printing and academic support services."],
      ["How we use data", "To create quotations, coordinate proof approvals, arrange printing/binding, ship completed orders, and provide customer support."],
      ["File confidentiality", "Uploaded documents are stored in secure cloud storage and are not shared with any third party. Files may be deleted on request after the order is delivered."],
      ["Third-party services", "We use standard courier and payment partners for delivery and payment processing. Only the minimum data required (name, address, contact) is shared with them."],
      ["Your rights", "You may request access to, correction of, or deletion of your data by emailing us at surajdubeyks@gmail.com."],
      ["Contact", "For any privacy concerns, contact Suraj Dubey at surajdubeyks@gmail.com."],
    ],
  },
  terms: {
    title: "Terms & Conditions",
    eyebrow: "Terms",
    intro: "By placing an order with ScholarPrintHub, you agree to the following terms of service.",
    sections: [
      ["Nature of services", "ScholarPrintHub provides academic support (editing, formatting, citation correction, plagiarism review), printing, and binding services. We do not guarantee academic outcomes or grades."],
      ["Quotations & payments", "All quotations are custom and valid for 7 days from issue. Work starts after confirmation and applicable advance payment."],
      ["Delivery timelines", "Timelines are indicative and depend on document scope, revisions, courier partner, and delivery location. Urgent delivery is available at additional cost."],
      ["Revisions", "Revisions are provided as per the agreed scope of work. Additional or out-of-scope revisions may be quoted separately."],
      ["Ownership & usage", "Final deliverables are for the customer's academic and personal reference. Customers are responsible for using the material in line with their institution's academic policies."],
      ["Refunds", "Refunds are considered on a case-by-case basis if work has not commenced or if the delivered material materially deviates from the agreed scope."],
    ],
  },
  disclaimer: {
    title: "Disclaimer",
    eyebrow: "Disclaimer",
    intro: "Please read the following disclaimer carefully before using our services.",
    sections: [
      ["Academic support only",
       "Our services are intended for academic support, editing, formatting, research guidance, citation correction, plagiarism checking, and document preparation assistance. Customers are responsible for using the final material according to their institution's academic policies. We do not encourage academic dishonesty. All work should be used for learning, reference, editing, and documentation support."],
      ["No guarantee of grades / acceptance", "We do not guarantee particular marks, journal acceptance, or degree outcomes. Success depends on many factors including your institution's evaluation criteria."],
      ["Third-party tools", "Similarity reports and plagiarism checks may be run using third-party tools; results are indicative and should be reviewed alongside human editorial judgement."],
      ["Contact", "If you have any questions, please write to us at surajdubeyks@gmail.com."],
    ],
  },
};

export default function LegalPage({ kind }) {
  const c = CONTENT[kind];
  return (
    <div data-testid={`legal-${kind}`} className="container-app py-16 max-w-3xl">
      <span className="section-eyebrow">{c.eyebrow}</span>
      <div className="divider-gold mt-2 mb-4" />
      <h1 className="font-display text-4xl sm:text-5xl text-navy">{c.title}</h1>
      <p className="mt-4 text-slate-600">{c.intro}</p>
      <div className="mt-10 space-y-8">
        {c.sections.map(([t, d], i) => (
          <section key={i} className="border-l-2 border-gold pl-4">
            <h2 className="font-display text-2xl text-navy">{t}</h2>
            <p className="mt-2 text-sm text-slate-700 leading-relaxed">{d}</p>
          </section>
        ))}
      </div>
      <div className="mt-12 text-xs text-slate-500">Last updated: 04 Feb 2026 · © 2026 ScholarPrintHub</div>
    </div>
  );
}
